import { Provider, observer } from 'mobx-react';
import React from 'react';
import { cache } from 'tm3-core/cache';
import Feature from 'tm3-core/controls/feature';
import PayFeatures from 'tm3-pay/features';
import TerminalPaymentDialog from './index';
import TerminalPaymentDialogStore, {
  TerminalPaymentDialogStoreCtx
} from './stores/terminal-payment-dialog-store';
interface IProps extends React.PropsWithChildren {}
@observer
class TerminalDialogWrapper extends React.Component<IProps> {
  store = new TerminalPaymentDialogStore();
  render() {
    const { children } = this.props;
    const clearAcceptTerminalFeature = cache.isClick
      ? PayFeatures.ClickClearAcceptTerminal
      : PayFeatures.ClearAcceptTerminal;

    return (
      <Provider terminalPaymentDialogStore={this.store}>
        <TerminalPaymentDialogStoreCtx.Provider value={this.store}>
          <>
            <Feature
              valueOr={[
                PayFeatures.SquareTerminal,
                clearAcceptTerminalFeature,
                PayFeatures.StripeTerminal
              ]}
              fallback={null}
            >
              <TerminalPaymentDialog />
            </Feature>
            {children}
          </>
        </TerminalPaymentDialogStoreCtx.Provider>
      </Provider>
    );
  }
}
export default TerminalDialogWrapper;
